import { Box, Flex, Input, Text } from '@chakra-ui/react'
import { LuSearch, LuX } from 'react-icons/lu'
import { useT } from '../../../i18n'

interface Props {
  value: string
  onChange: (v: string) => void
  showNoResults: boolean
}

export function SearchToolbar({ value, onChange, showNoResults }: Props) {
  const { t } = useT()
  return (
    <Box>
      <Flex
        alignItems="center"
        gap={2}
        bg="white"
        border="1px solid"
        borderColor="gray.200"
        borderRadius="md"
        px={3}
        py={2}
        maxW="480px"
      >
        <LuSearch size={16} color="#857b71" />
        <Input
          variant="outline"
          border="none"
          outline="none"
          _focus={{ boxShadow: 'none' }}
          placeholder={t('origen.componentes.searchPlaceholder')}
          value={value}
          onChange={(e) => onChange(e.target.value.slice(0, 200))}
          maxLength={200}
          flex="1"
          size="sm"
        />
        {value && (
          <Box
            as="button"
            type="button"
            aria-label={t('origen.componentes.clearSearch')}
            onClick={() => onChange('')}
            p={1}
            borderRadius="sm"
            _hover={{ bg: 'gray.100' }}
          >
            <LuX size={14} color="#857b71" />
          </Box>
        )}
      </Flex>
      {showNoResults && (
        <Text mt={2} fontSize="sm" color="gray.600">
          {t('origen.componentes.noResults')}
        </Text>
      )}
    </Box>
  )
}
